import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcAlerts = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5 9.5a7 7 0 1 1 14 0v3l1.277 2.553a1 1 0 0 1-.895 1.447H4.618a1 1 0 0 1-.894-1.447L5 12.5v-3Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M9 18.5h6a3 3 0 1 1-6 0Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcAlerts");

export { IcAlerts };
//# sourceMappingURL=ic-alerts.js.map
